import React from "react";
import PropTypes from "prop-types";
import { Message } from "semantic-ui-react";

const ErrorMessage = ({ text, error }) => {
  return (
    <Message error>
      {text ? (
        <Message.Content content={text} />
      ) : (
        error.data && <Message.Content content={error.data.message} />
      )}
    </Message>
  );
};

ErrorMessage.propTypes = {
  error: PropTypes.any,
  text: PropTypes.string,
};

export default ErrorMessage;
